import React, { useEffect, useState } from "react";
import { usePlatformAuth } from "context/PlatformAuthContext";
import { platformApiService } from "services/platformApi";
import { useNavigate } from "react-router-dom";

const PlatformPlans: React.FC = () => {
 const { isAuthenticated } = usePlatformAuth();
 const navigate = useNavigate();
 const [plans, setPlans] = useState<any[]>([]);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
  if (!isAuthenticated) {
   navigate("/platform/login", { replace: true });
   return;
  }

  fetchPlans();
 }, [isAuthenticated, navigate]);

 const fetchPlans = async () => {
  try {
   const response = await platformApiService.getPlans();
   setPlans(response.data.plans || []);
  } catch (error) {
   console.error("Error fetching plans:", error);
  } finally {
   setLoading(false);
  }
 };

 if (loading) {
  return <div className="p-8">Loading plans...</div>;
 }

 return (
  <div className="p-8">
   <div className="mb-6 flex justify-between items-center">
    <h1 className="text-3xl font-bold">Subscription Plans</h1>
    <button
     onClick={() => navigate("/platform/plans/new")}
     className="px-4 py-2 bg-blue-600 text-white hover:bg-blue-700"
    >
     Create Plan
    </button>
   </div>
   <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
    {plans.map((plan) => (
     <div key={plan._id} className="bg-white shadow p-6">
      <h3 className="text-xl font-semibold mb-2">{plan.name}</h3>
      <p className="text-gray-600 mb-4">{plan.description}</p>
      <div className="mb-4">
       <span className="text-3xl font-bold">${plan.price}</span>
       <span className="text-gray-500">/month</span>
      </div>
      <ul className="list-disc list-inside mb-4 text-sm text-gray-600">
       {plan.features?.map((feature: string, idx: number) => (
        <li key={idx}>{feature}</li>
       ))}
      </ul>
      <div className="flex gap-2">
       <button
        onClick={() => navigate(`/platform/plans/${plan._id}`)}
        className="flex-1 px-4 py-2 bg-blue-600 text-white hover:bg-blue-700"
       >
        Edit
       </button>
      </div>
     </div>
    ))}
   </div>
  </div>
 );
};

export default PlatformPlans;

